import React, { useState, useEffect } from "react";
import SelectComponent, { components } from "react-select";

import * as S from "./styles";
import { compact } from "lodash";

const styles = {
  loadingMessage: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  option: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  input: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  menu: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  placeholder: (styles) => ({ ...styles, fontFamily: "Roboto" }),
  singleValue: (styles) => ({ ...styles, fontFamily: "Roboto" }),
};

const SearchableSelect = ({
  getCustomLabel,
  entries,
  label,
  labelStyles,
  parser = (item) => item || {}, // should parse to {value: yourValue, label: yourLabel}
  placeholder,
  selected,
  setSelected, //function
  ...other
}) => {
  const [options, setOptions] = useState([]);
  const [key, setKey] = useState(new Date());

  useEffect(() => {
    // this is an workaround for selection clearing works
    if (!selected) {
      setKey(new Date());
    }
  }, [selected]);

  useEffect(() => {
    const parsed = compact(entries).map((entry) => ({
      ...parser(entry),
      rawEntry: entry,
    }));
    setOptions(parsed);
  }, [entries]);

  const onChange = (item) => {
    setSelected(item.rawEntry);
  };

  const OptionComponent = (optionProps) => {
    const { data } = optionProps;
    if (getCustomLabel) {
      return (
        <components.Option {...optionProps}>
          {getCustomLabel(data.rawEntry)}
        </components.Option>
      );
    }
    return <components.Option {...optionProps}>{data.label}</components.Option>;
  };

  return (
    <>
      <S.Wrapper>
        <S.Main>
          {label && <S.Label {...labelStyles}>{label}</S.Label>}
          <SelectComponent
            {...other}
            key={key}
            components={{ Option: OptionComponent }}
            closeMenuOnSelect
            value={
              selected
                ? options.filter(
                    (option) => option.value === parser(selected).value
                  )
                : null
            }
            defaultValue={selected ? parser(selected).value : null}
            isSearchable
            loadingMessage={() => "Carregando..."}
            name={label}
            noOptionsMessage={() => "Nenhum dado encontrado"}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            styles={styles}
          />
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default SearchableSelect;
